'use client';

import { useState, useEffect } from 'react';
import type { ServiceBotNode } from 'data-layer';
import { ServiceBotSkeleton } from './partials';
import styles from './ServiceBot.module.css';
import clsx from 'clsx';

export function ServiceBot({ botId, apiUrl, src }: ServiceBotNode) {
  const [loaded, setLoaded] = useState(false);
  const [skeletonMounted, setSkeletonMounted] = useState(true);

  useEffect(() => {
    customElements.whenDefined('botario-chat').then(() => setLoaded(true));
  }, []);

  return (
    <section id="service-bot" className={clsx(styles['wrapper'], 'center--content')}>
      <div className={styles['container']}>
        {skeletonMounted && (
          <ServiceBotSkeleton
            hidden={loaded}
            onTransitionEnd={() => loaded && setSkeletonMounted(false)}
          />
        )}
        {/* The widget adds attributes (ng-version, style, classes) to its host before hydration */}
        <botario-chat suppressHydrationWarning className={styles['chat']} bot-id={botId} api-url={apiUrl} />
      </div>
      <script src={src} type="module" async />
    </section>
  );
}
